import { BaseControl } from './../dynamic-form/shared/controls/base-control';
import { InformacionTablaMaestra } from './tabla-maestra.model';
import { LocalDataSource } from 'ng2-smart-table';
import { Partial } from 'lodash';
import { ColumnsTableModalSelect } from './modal-select.model';

export type AccionSincronizacionTabla = 'agregar' | 'modificar' | 'eliminar';
// tslint:disable-next-line: max-line-length
export type SiEs = 'Igual' | 'Diferente' | 'Vacio' | 'Mayor a' | 'Mayor o igual a' | 'Menor a' | 'Menor o igual a' | 'Se encuentra en los registros' | 'No se encuentra en los registros';
export type Accion = 'Bloquear' | 'Desbloquear' | 'Ocultar' | 'Mostrar' | 'Lectura' | 'Escritura' | 'Asignar valor' | 'Asignar valor maestra' | 'Validar expresion' | 'Limpiar expresion';
export type OperadorCondicion = 'Y' | 'O';
export type AccionDocumento = 'generar' | 'radicar' | 'subir';
export type Pestana = 'revisiones' | 'formularios' | 'gestion_documentos' | 'radicacion' | 'anexos' | 'radicacion_especial' | 'remision_funcionarios' | 'con_copia_a' | 'en_respuesta_de' | 'enviado_por';

export interface DateCondiction {
  valueControl: Date;
  valueCondiction: Date;
}

export interface DatesCondiction {
  valueControl: Date[];
  valueCondiction: Date;
}

export interface OrdenPestanas {
  orden: number;
  pestana: Pestana;
  requerido: boolean;
  nombre: string;
  modificable?: boolean;
}

export interface PestanasModificables {
  orden?: number;
  pestana?: Pestana;
  requerido?: boolean;
  nombre?: string;
  modificable?: boolean;
}

/**
 * Modelo de los controles del formulario
 *
 * @export
 * @class Control
 */
export class Control {
  id?: number;
  nombre_campo: string;
  placeholder: string;
  label: string;
  tooltip?: string;
  requerido: boolean;
  orden: number;
  tipo_campo: TipoControl;
  espacio: number;
  validaciones: ValidacionesControl;
  propiedades: any; // diferentes propiedades individuales de los controles
  estilos: Array<any>; // estilos css clases, etc..
  lista_maestra: Array<InformacionTablaMaestra>; // relacion a maestras
  alias: string;
  tipos_documentales_selector?: Array<any>;
  sincronizado: boolean;
  dato_radicacion?: string; // Aplica para controles de tipo texto y numero
}

/**
 * Modelo de los tipos de controles del formulario
 *
 * @export
 * @class TipoControl
 */
export class TipoControl {
  id: number;
  nombre: string;
  descripcion: string;
}

/**
 * Modelo de los tamaños de los controles
 *
 * @export
 * @class EspacioControl
 */
export class EspacioControl {
  nombre: string;
  espacio: number;
}

/**
 * Lista de las diferentes formas creadas
 *
 * @export
 * @class ListaForma
 */
export class ListaForma {
  nombre: string;
  versiones: Array<VersionForma>;
}

/**
 * Modelo de versiones de las formas
 * Complemento de las listas de formas
 *
 * @export
 * @class VersionForma
 */
export class VersionForma {
  id: number;
  version: number;
  descripcion?: string;
}

/**
 * Modelo de lista de las formas
 *
 * @export
 * @class FormaTabla
 */
export class FormaTabla {
  id: number;
  nombre: string;
  descripcion: string;
  version: number;
  versiones: Array<VersionForma>;
}

/**
 * Modelo de la forma principal
 *
 * @export
 * @class Forma
 */
export class Forma {
  id: number;
  nombre?: string;
  alias: string;
  descripcion?: string;
  orden?: number;
  version?: number;
  estilo?: any;
  tabla?: boolean;
  documento: boolean;
  sub_formas?: Array<SubForma>;
  sub_formulario?: number;
  condicion: boolean;
  condiciones: Array<CondicionForma>;
  asociaciones: Array<AsociacionTareaForma>;
  numero_registros: number;
  radicado: boolean;
  documentos_formulario?: Documentos_Fomrulario[];
}

/**
 * modelo de las subformas de la forma principal
 * Complemento de forma
 *
 * @export
 * @class SubForma
 */
export class SubForma {
  id_forma: number;
  nombre?: string;
  alias: string;
  descripcion?: string;
  estilo?: any;
  orden?: number;
  tabla?: boolean;
  campos?: Array<Control>;
  sub_formulario?: any;
  configuracion_tabla?: any;
  hidde?: boolean;
  datos?: LocalDataSource;
  formulario?: Array<BaseControl<Partial>>;
  condiciones: Array<CondicionForma>;
  asociaciones: Array<AsociacionTareaForma>;
  numero_registros: number;
  control_documentos?: Array<number>
  pestanas?: boolean;
}

/**
 * Modelo de la forma que se envia a el endpoint dynamicForm
 *
 * @export
 * @class FormaGeneral
 */
export class FormaGeneral {
  id_forma: number;
  nombre: string;
  alias: string;
  descripcion: string;
  estilo: any;
  orden: number;
  tabla: boolean;
  documento: boolean;
  campos: Array<ControlGeneral>;
  sub_formulario: number;
  condicion: boolean;
  condiciones: Array<CondicionForma>;
  asociaciones: Array<AsociacionTareaForma>;
  radicado: boolean;
  numero_registros: number;
  lista_chequeo: boolean;
  control_documentos?: Array<number>;
  documentos_formulario?: Documentos_Fomrulario[];
}

/**
 *Modelo de los documentos del formulario
 *
 * @export
 * @interface Documentos_Fomrulario
 */
export interface Documentos_Fomrulario {
  tipo_documental: number;
  funciones?: Funciones[];
}

/**
 *Modelo de las funciones de los documentos del formulario
 *
 * @export
 * @interface Funciones
 */
export interface Funciones {
  id?: number;
  funcion?: number;
  funcion_nombre?: string;
  requerido?: boolean;
}

/**
 * modelo de los controles de la forma general
 * Complemento de FormaGeneral
 *
 * @export
 * @class ControlGeneral
 */
export class ControlGeneral {
  nombre_campo: string;
  placeholder: string;
  tooltip?: string;
  label: string;
  requerido: boolean;
  orden: number;
  tipo_campo: number;
  espacio: number;
  validaciones: ValidacionesControl;
  propiedades: any; // diferentes propiedades individuales de los controles
  estilos: Array<any>; // estilos css clases, etc..
  lista_maestra: number; // relacion a maestras
  alias: string;
  tipos_documentales_selector?: Array<any>;
  sincronizado: boolean;
  dato_radicacion: any; //Se agrega el dato radicacion de tipo any ya que puede recibir texto o numeros
}

/**
 * Modelo de los datos de los formularios de las formas dinamicas
 *
 * @export
 * @class Datos
 */
export class Datos {
  id?: number;
  nombre_campo: string;
  nombre: string;
  alias_formulario: string;
  alias: string;
  valor: any;
  tipo: string;
  clasificacion?: string;
  valueSelects?: string;
  condicion?: boolean;
  id_opcion?: number;
}

/**
 * Modelo de los datos de las tablas de las formas dinamicas
 *
 * @export
 * @class TablaDatos
 */
export class TablaDatos {
  id_tabla: number;
  nombre: string;
  alias: string;
  labels: any;
  valueSelects: any;
  valores: Array<any>;
}

/**
 * Complemento del modelo ListaFormaDefault
 *
 * @export
 * @class FormaVersion
 */
export class FormaVersion {
  id: number;
  version: number;
  condicion?: boolean;
  radicado?: boolean;
  estilo?: any;
  documento?: boolean;
}

/**
 * Modelo de lista de todas las formas del sistema tanto como las formas dinamicas como las formas especificas
 * endpoint: dynamicFormVersion
 *
 * @export
 * @class ListaFormaDefault
 */
export class ListaFormaDefault {
  nombre: string;
  nombre_alternativo: string;
  descripcion: string;
  forma_especifica: boolean;
  versiones: Array<FormaVersion>;
}

/**
 * Modelo de la asociacion del alias de la tarea con la forma
 *
 * @export
 * @class AsociacionTareaForma
 */
export class AsociacionTareaForma {
  idForma: number;
  nombreForma: string;
  aliasAsociacion: string;
  version: number;
  index?: number;
}

/**
 * Modelo de las condiciones de la forma
 *
 * @export
 * @class CondicionForma
 */
export class CondicionForma {
  formaInicia: string;
  formularioInicia: string;
  campoInicia: string;
  siEs: SiEs;
  valor?: any;
  accion: Accion;
  formularioCondicionado: string;
  campoCondicionado: string;
  valorAsignar?: any;
  fechaActualAsignar?: boolean;
  operadorCondicion?: OperadorCondicion;
  fechaActual?: boolean;
  maestra?: any;
  columnaMaestra?: any;
  columnaCondicionar?: any;
  valorMaestra?: any;
  valorReferencia?: any;
  operarResultado?: any;
  mantenerSesion?: any;
  validarColumna?: any;
  index?: number;
  fomularioComparison?: string;
  campoComparison?: string;
}

/**
 * Modelo de las condiciones de el documento
 *
 * @export
 * @class CondicionDocumento
 */
export class CondicionDocumento {
  forma: string;
  formulario: string;
  campo: string;
  siEs: SiEs;
  valor?: any;
  accion: Accion;
  accionDocumento: AccionDocumento;
  formaDocumento: string;
  documento?: number;
  nombre_documento?: string;
  operadorCondicion?: OperadorCondicion;
  fechaActual?: boolean;
  index?: number;
}

/**
 * Modelo de las condiciones basicas del control de los formularios
 *
 * @export
 * @class CondicionControl
 */
export class CondicionControl {
  campoDepende: string;
  siEs: SiEs;
  valor?: any;
  accion: Accion;
  valorAsignar?: any;
  fechaActualAsignar?: boolean;
  operadorCondicion?: OperadorCondicion;
  fechaActual?: boolean;
  maestra?: any;
  columnaMaestra?: any;
  columnaCondicionar?: any;
  valorMaestra?: any;
  valorReferencia?: any;
  operarResultado?: any;
  mantenerSesion?: any;
  validarColumna?: any;
  index?: number;
  expresion?: any;
  mensajeExpresion?: Text;
}

/**
 * Modelo de las condiciones generales de un control
 *
 * @export
 * @class ValidacionesControl
 */
export class ValidacionesControl {
  condiciones: Array<CondicionControl>;
  operaciones: Array<OperacionesControl>;
  filtros?: Array<FiltrosSelectores>;
  condiciones_columnas?: Array<CondicionColumnaSelector>;
}

/**
 * Modelo de las validaciones de las columnas de tablas maestras
 *
 * @export
 * @class ValidacionesColumnaMaestra
 */
export class ValidacionesColumnaMaestra {
  condiciones: Array<CondicionControl>;
  filtros?: Array<FiltrosSelectores>;
}

/**
 * Modelo de una operacion de un control
 *
 * @export
 * @class OperacionesControl
 */
export class OperacionesControl {
  index?: number;
  operacion: string;
  valores: Array<ValoresOperacionesControl>;
  ejecutar_siempre: boolean;
}

/**
 * Modelo de la configuracion del valor de una referencia dentro de una operacion
 *
 * @export
 * @class ValoresOperacionesControl
 */
export class ValoresOperacionesControl {
  index?: number;
  forma?: string;
  formulario?: string;
  campo?: string;
  consulta?: string;
  valor: string;
  referencia: string;
}

/**
 * Modelo de los filtros en los campos de maestras y formas dinamicas
 *
 * @export
 * @class FiltrosSelectores
 */
export class FiltrosSelectores {
  columna: string;
  form?: string;
  formulario?: string;
  field?: string;
  validarCampo?: boolean;
  valor?: string;
  operador: string;
  index?: number;
  condicional?: string;
}

/**
 * Modelo de las opciones de columnas aseleccionar el la configuracion de selectores
 *
 * @export
 * @class OptionsColumns
 */
export class OptionsColumns {
  key: string;
  value: string;
  masterDependencia: string;
  column: string;
  type: string;
  category?: string;
  columnsSelectorModal?: ColumnsTableModalSelect[];
}

/**
 * Modelo de la informacion emitida de el componente de refactorizacion de formularios dinamicos
 * cuando se guarda un formulario
 *
 * @export
 * @class InformacionGuardadaFormulario
 */
export class InformacionGuardadaFormulario {
  data: any;
  subForm: SubForma;
}

/**
 * Modelo de informacion de campos para sincronizar
 * End-point: synchronizationForms
 *
 * @export
 * @class DatosSincronizacion
 */
export class DatosSincronizacion {
  formulario?: SincronizacionFormulario;
  tabla?: SincronizacionTabla;
  tareas: Array<number>;
}

/**
 * Modelo de informacion para sincronizar los campos de un formulario
 * Complemento de DatosSincronizacion
 *
 * @export
 * @class SincronizacionFormulario
 */
export class SincronizacionFormulario {
  data: Array<DatosSincronizacionFormulario>;
}

/**
 * Modelo de la informacion a sincronizar de un campo
 * Complemento de SincronizacionFormulario
 *
 * @export
 * @class DatosSincronizacionFormulario
 */
export class DatosSincronizacionFormulario {
  valor: any;
  valueSelects?: string;
  alias: string;
  campos: Array<CamposSincronizar>;
}

/**
 * Modelo de la informacion del campo a sincronizar
 * Complemento de DatosSincronizacionFormulario
 *
 * @export
 * @class CamposSincronizar
 */
export class CamposSincronizar {
  id_tarea: number;
  id_campo: number;
  alias_formulario: string;
  nombre_campo: string;
  nombre: string;
  tipo: string;
  clasificacion?: string;
  condicion?: boolean;
  id_opcion?: number;
}

/**
 * Modelo de informacion para sincronizar una tabla
 * Complemento de DatosSincronizacion
 *
 * @export
 * @class SincronizacionTabla
 */
export class SincronizacionTabla {
  valor: Array<DatosSincronizacionTabla>;
}

/**
 * Modelo de la informacion a sincronizar de un registro en una tabla
 * Complemento de SincronizacionTabla
 *
 * @export
 * @class DatosSincronizacionTabla
 */
export class DatosSincronizacionTabla {
  tarea: number;
  data: any;
  id_tabla: number;
  accion: AccionSincronizacionTabla;
  alias: string;
  id_registro: string;
  valueSelects: any;
}

/**
 * Modelo de un campo sincronizado
 * complemento de FormaSincronizado
 *
 * @export
 * @class ControlSincronizado
 */
export class ControlSincronizado {
  id: number;
  nombre_campo: string;
  alias: string;
  tipo_campo: TipoControl;
  sincronizado: boolean;
  propiedades: any;
  label: string;
}

/**
 * Modelo de una forma de la tarea asociada
 * Complemento de TareaSincronizada
 *
 * @export
 * @class FormaSincronizado
 */
export class FormaSincronizado {
  id_forma: number;
  alias: string;
  nombre: string;
  tabla: boolean;
  campos: Array<ControlSincronizado>;
  sub_formulario?: number;
  estilos: any;
}

/**
 * Modelo de las formas de las tareas asociadas con campos sincronizados
 * End-point: getFormTaskSync
 *
 * @export
 * @class TareaSincronizada
 */
export class TareaSincronizada {
  id_tarea: number;
  alias?: string;
  forma: Array<FormaSincronizado>;
}

/**
 * Modelo de la informacion para duplicar la forma
 *
 * @export
 * @class DuplicacionForma
 */
export class DuplicacionForma {
  subformas_ids: Array<number>;
  forma_destino_data: FormaDestinoDuplicacion;
}


/**
 * Modelo de la informacion de la forma de destino para la duplicacion de forma
 *
 * @export
 * @class FormaDestinoDuplicacion
 */
export class FormaDestinoDuplicacion {
  origen_id: number;
  nombre: string;
  alias: string;
  descripcion: string;
}

/**
 * Modelo de las configuraciones de acceso a las maestras
 *
 * @export
 * @class AccesoMaestra
 */
export class AccesoMaestra {
  id_maestra: number;
  nombre_maestra: string;
  agregar: boolean;
  modificar: boolean;
  eliminar: boolean;
}

/**
 * Modelo de las condiciones de columnas de tablas dinamicas
 *
 * @export
 * @class CondicionColumna
 */
export class CondicionColumna {
  columna: string;
  accion: string;
  valor: string;
  mensaje: string;
  index?: number;
}

/**
 * Modelo de condicion de las columnas a traer en los selectores
 *
 * @export
 * @class CondicionesColumnas
 */
export class CondicionColumnaSelector {
  forma: string;
  formulario: string;
  campo: string;
  siEs: SiEs;
  valor: any;
  columnas: string[];
  nombre_columnas: string;
  placeholder: string;
  columnas_selector_modal: ColumnsTableModalSelect[];
  fechaActual?: boolean;
  index?: number;
}

/**
 * Modelo los documentos a cargar el el selector de tipo radicados del sistema
 *
 * @export
 * @class TramiteAsociar
 */
export class TramiteAsociar {
  tramite_id: number;
  expediente: string;
  radicado: string;
  fecha_radicado: string;
  tipo_documental: string;
}

/**
 * Modelo de las opciones de la lista de chequeo
 *
 * @export
 * @class OpcionesListaChequeo
 */
export class OpcionesListaChequeo {
  label: string;
  valor: string;
  por_defecto: boolean;
  index?: number;
}

/**
 * Modelo de la consulta de listas de chequeo de una forma dinamica
 *
 * @export
 * @class FormaListasChequeo
 */
export class FormaListasChequeo {
  id_forma: number;
  formularios: FormularioListaChequeo[];
}

/**
 * Modelo de un formulario de la consulta de listas de chequeo de una forma dinamica
 *
 * @export
 * @class FormularioListaChequeo
 */
export class FormularioListaChequeo {
  id_formulario: number;
  alias: string;
  nombre: string;
  estilo: any;
  campos: CampoFormularioListaChequeo[];
}

/**
 * Modelo de un campo de un formulario de la consulta de listas de chequeo de una forma dinamica
 *
 * @export
 * @class CampoFormularioListaChequeo
 */
export class CampoFormularioListaChequeo {
  id: number;
  nombre: string;
  alias: string;
}

/**
 * Modelo de configuracion valores por defecto de las maestras de los selectores
 *
 * @export
 * @class ValoresMaestraPorDefectoSeletor
 */
export class ValoresMaestraPorDefectoSeletor {
  columna: string;
  tipo_valor: 'formulario' | 'especifico';
  forma: string;
  formulario: string;
  campo: string;
  valor: any;
  bloquear: boolean;
  index?: number;
  texto_columna?: string;
  texto_valor?: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/formulario-dinamico.model.ts